import CryptoJS from "crypto-js";

const key = `${process.env.REACT_APP_TITIANS}`;
export const encryptContent = (value: any | null) => {
  if (!value) return null;
  return CryptoJS.AES.encrypt(JSON.stringify(value), key).toString();
};

export const decryptContent = (value: any | null) => {
  if (!value) return null;
  const bytes = CryptoJS.AES.decrypt(value, key);
  return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
};

export const saveSecurely = (key: string, value: unknown) => {
  const jsonValue = JSON.stringify(value);
  return localStorage.setItem(key, jsonValue);
};

export const fetchSecurely = (key: string) => {
  const jsonValue = localStorage.getItem(key);
  return jsonValue != null ? JSON.parse(jsonValue) : null;
};

export const deleteSecurely = async (key: string) => {
  return await localStorage.removeItem(key);
};
